import type { Cache, UpdatesConfig } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { RentersInterestedPartyDeleteMutation, RentersInterestedPartyDeleteMutationVariables } from '@/graphql/generated/graphql';

const rentersInterestedPartyDelete: UpdatesConfig['Mutation'] = {
  rentersInterestedPartyDelete: (data: RentersInterestedPartyDeleteMutation, variables: RentersInterestedPartyDeleteMutationVariables, cache: Cache) => {
    invalidateQuery<RentersInterestedPartyDeleteMutationVariables>('skypadPolicyUnique', cache, {
      policy_number: variables.policy_number,
    });
  },
};

export default rentersInterestedPartyDelete;
